import Gifts from '@/models/supplierPanel/Gifts';
const getDefaultState = () => ({
  gifts: [],
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setGifts(state, payload) {
      state.gifts = payload;
    },
  },

  actions: {
    async getGifts({ commit }, query) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await Gifts.get(query);
        const { gifts, pagination } = data.data;

        commit('setGifts', gifts);
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },
  },
};
